module.exports = __webpack_public_path__ + "src/class2/img/image.fba604e8.png";